import React, { Component } from 'react';
import PropTypes from 'prop-types';
import createHistory from 'history/createBrowserHistory';
import Flickity from 'flickity';
import Step0 from './Step0';
import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';
import Step4 from './Step4';
import Step5 from './Step5';
// import PackageViewer from './PackageViewer';
import professions from './professions.js';
import fetchHelpers from '../../helpers/fetchHelpers';
import graphqlHelpers from '../../helpers/graphql';
import _ from 'lodash';

class CoursePicker extends Component {
  constructor (props) {
    super(props);
    this.state = {
      currentStep: 0,
      professionId: 0,
      serverError: '',
      isLoading: false
    };
    this.previousClickHandler = this.previousClickHandler.bind(this);
    this.nextClickHandler = this.nextClickHandler.bind(this);
    this.getLevels = this.getLevels.bind(this);
    this.updateSlide = this.updateSlide.bind(this);
    this.redirectToApp = this.redirectToApp.bind(this);
    this.history = createHistory({
      basename: props.rootPath
    });
    // need to complete the course-picker again if you refresh the page.
    let path = this.history.location.pathname;
    let isCoursePicker = (path.indexOf('course-picker') > -1);
    if (isCoursePicker) {
      this.history.push('/', { some: 'state' });
    }
    // Listen for changes to the current location.
    this.history.listen((location, action) => {
      this.updateSlide();
    });
  }

  updateSlide () {
    // location is an object like window.location
    // action, location.pathname, location.state
    // if the location contains course-picker then update our state.
    let path = this.history.location.pathname;
    // need to get from the window for the edge cases
    // where history is not updated (clicking home button)
    let windowPath = window.location.href;
    let isCoursePicker = (windowPath.indexOf('course-picker') > -1);
    let step = 0;
    if (this.props.autoStart) {
      step = 1;
    }
    if (isCoursePicker) {
      step = Number(path[path.length - 1]);
    }
    let state = this.state;
    if (step !== state.currentStep) {
      this.flkty.select(step);
      window.scrollTo(0, 0);
      state.currentStep = Number(step);
      this.setState(state);
    }
  }

  componentDidMount () {
    const flickityOptions = {
      initialIndex: 0,
      adaptiveHeight: true,
      pageDots: false,
      prevNextButtons: false,
      autoplay: false,
      draggable: false,
      wrapAround: false,
      accessibility: false,
      selectedAttraction: 0.08,
      friction: 0.5,
      cellAlign: 'left'
    };
    this.flkty = new Flickity(this.carousel, flickityOptions);
    if (this.props.autoStart) {
      this.nextClickHandler({});
    }
  }

  previousClickHandler () {
    let state = this.state;
    let nextStep = Math.max(0, state.currentStep - 1);
    if (nextStep === 0) {
      this.history.push('/', { some: 'state' });
    } else {
      this.history.push('/course-picker/' + nextStep, { some: 'state' });
    }
    if (state.serverError !== '') {
      state.serverError = '';
      this.setState(state);
    }
  }

  redirectToApp () {
    fetchHelpers.redirectToApp(this.state.customer.token);
  }

  postToServer () {
    const self = this;
    let newState = self.state;
    newState.isLoading = true;
    self.setState(newState);
    fetchHelpers.postToPlan(this.state, function (data) {
      if (data.status === 'success' && data.statusCode === 200) {
        // success
        window.fbq('track', 'Lead');
        let newState = self.state;
        newState.customer.token = data.token;
        self.setState(newState);
        if (self.state.customer.news) {
          graphqlHelpers.signupToMailingList(self.state.customer).then(response => {
            if (response.mailingListMutation.success) {
              console.log('signup success');
            }
          });
        }
        self.history.push('/course-picker/5');
      } else {
        // show validation / error message
        let newState = self.state;
        newState.serverError = data.message;
        newState.isLoading = false;
        newState.customer.token = data.token;
        self.setState(newState);
      }
    });
  }

  nextClickHandler (extraState) {
    let state = this.state;
    let newState = Object.assign(state, extraState);
    newState.serverError = '';
    this.setState(newState);
    if (state.currentStep < 4) {
      this.history.push('/course-picker/' + (state.currentStep + 1), { some: 'state' });
    } else {
      this.postToServer();
    }
  }

  getLevels () {
    let desiredProfessionId = this.state.profession || 1;
    let desiredProfession = _.filter(professions, (p) => {
      return p.id === desiredProfessionId;
    })[0];
    let levels = desiredProfession.levels;
    // also filter by current level if that is specified.
    // can only choose courses about current level.
    if (this.state.currentLevel) {
      levels = _.filter(levels, (l) => l > this.state.currentLevel);
    }
    return levels;
  }

  componentDidUpdate (prevProps, prevState) {
    // unfortunately clicking the home button on this site
    // will update the url without firing the history event
    // but it will call this method
    // so need to check for update here. (to take it back to step0)
    this.updateSlide();
  }

  /* to test packages stick this below the hero
  <div style={{position:'absolute', top:100, right:100}}>
    <PackageViewer stepState={this.state} />
  </div>
  */

  render () {
    return (
      <section className='hero'>
        <div className='l-container'>
          <div ref={(element) => { this.carousel = element; }} className='registration js-registration'>
            <Step0 handleNextClick={this.nextClickHandler} />
            <Step1
              professions={professions}
              handlePreviousClick={this.previousClickHandler}
              handleNextClick={this.nextClickHandler} />
            <Step2
              handlePreviousClick={this.previousClickHandler}
              handleNextClick={this.nextClickHandler} />
            <Step3
              getLevels={this.getLevels}
              professions={professions}
              professionId={this.state.professionId}
              handlePreviousClick={this.previousClickHandler}
              handleNextClick={this.nextClickHandler} />
            <Step4
              handlePreviousClick={this.previousClickHandler}
              handleNextClick={this.nextClickHandler}
              serverError={this.state.serverError}
              isLoading={this.state.isLoading} />
            <Step5 handleNextClick={this.redirectToApp} />
          </div>
        </div>
      </section>
    );
  }
}

CoursePicker.propTypes = {
  rootPath: PropTypes.string,
  autoStart: PropTypes.bool
};

export default CoursePicker;



// WEBPACK FOOTER //
// ./src/components/CoursePicker/index.js